import { ServerModelWithDateStrings } from "@teamprevent/common/utils";
import { format } from "date-fns";

import { AddTaskModel, CreateTaskDto, CreateTaskModel } from "../../task/model";

export const mapAddTaskModelToCreateTaskDto = (task: AddTaskModel): CreateTaskDto => ({ // eslint-disable-line deprecation/deprecation, max-len
    ...task,
    taskType: task.type,
    taskCodeId: task.taskCodeId,
    localDueDate: task.dueDate ? new Date(task.dueDate) : undefined,
    notes: task.notes,
    immunisationTypeTasks: task.immunisationTypeTasks,
    medicalTypeIds: task.medicalIds,
    immunisationTypeTaskIds: task.immunisationTypeTaskIds,
    assignedUsers: task.assignedUsers,
    eppDecision: task.eppDecision,
    precedingTaskId: task.precedingTaskId,
    amount: task.amount
});

export const mapAddTaskModelToCreateTaskModel = (task: AddTaskModel): CreateTaskModel => ({ // eslint-disable-line deprecation/deprecation, max-len
    ...task,
    taskType: task.type,
    dueDate: task.dueDate ? new Date(task.dueDate) : undefined,

});

export const mapCreateTaskModelToServer = (task: CreateTaskModel): ServerModelWithDateStrings<CreateTaskModel> => ({
    ...task,
    dueDate: task.dueDate ? format(task.dueDate, "yyyy-MM-dd'T'HH:mm:ss") : undefined,
});

export const mapCreateTaskDtoToServer = (task: CreateTaskDto): ServerModelWithDateStrings<CreateTaskDto> => ({
    ...task,
    localDueDate: task.localDueDate ? format(task.localDueDate, "yyyy-MM-dd'T'HH:mm:ss") : undefined,
});
